webpackJsonp([56753398129186],{

/***/ 2072:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"TriggerIgnoreProvider","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"username","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-trigger-ignore-provider-f881d6691bf45a503eb2.js